/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import SelectInput from 'components/input/SelectInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import EducationConfig from './EducationConfig';
import { setArrayLength, siblingEducationOptions } from 'components/helper/helper';
import YesNoSwitch from 'components/input/YesNoSwitch';
import Grid from '@mui/joy/Grid';

interface Props {
  formik: any;
  formItem: any;
  check?: any;
  indexExpand?: any;
  isMobile?: boolean;
  disabled?: boolean;
}

const Education = (props: Props) => {
  // const { isMobile = false } = props;
  React.useEffect(() => {
    props.formItem.setFieldValue(
      'parent_graduation_college_array',
      setArrayLength(
        props.formItem.values.parent_graduation_college_array,
        props.formItem.values.total_number_institutions_attended
      )
    );
    props.formItem.handleSubmit();
  }, [props.formItem.values.total_number_institutions_attended]);

  return (
    <>
      <Grid xs={12}>
        <div className="text-dart fs-5">Education</div>
      </Grid>
      
      <Grid xs={12} md={6}>
        <SelectInput
          logo="span-cm-logo"
          form={props.formik}
          option={siblingEducationOptions}
          name="education_level"
          values={props.formik.values.education_level}
          onChange={props.formik.handleChange}
          label="Education Level*"
          isSatTest={true}
          isMissing={!props.formik.values.education_level && props.check}
          disabled={props.disabled}
        />
      </Grid>
      
      <Grid xs={12}>
        <YesNoSwitch
          hidden={
            props.formik.values.education_level !==
            `Graduated from a trade school or community college` &&
            props.formik.values.education_level !== `Graduated from college/university`
          }
          logo="span-uc-logo"
          values={props.formik.values.csu_info?.parent_graduate_within_the_last_five_years}
          name="csu_info.parent_graduate_within_the_last_five_years"
          onChange={props.formik.handleChange}
          onClear={() =>
            props.formik.setFieldValue('csu_info.parent_graduate_within_the_last_five_years', '')
          }
          label="Did this parent graduate within the last five years?"
          disabled={props.disabled}
        />
      </Grid>
      
      {[
        'Some trade school or community college',
        'Graduated from a trade school or community college',
        'Some college/university',
        'Graduated from college/university',
        'Graduate school',
      ].includes(props.formik.values.education_level) && (
          <>
            <Grid xs={12}>
              <GroupRadioButton
                label="Total number of institutions attended*"
                className="pt-3 mb-3"
                columns={5}
                logo="span-cm-logo"
                mdCol={1}
                name="total_number_institutions_attended"
                values={props.formItem.values.total_number_institutions_attended}
                onChange={props.formItem.handleChange}
                options={[
                  { value: '1' },
                  { value: '2' },
                  { value: '3' },
                  { value: '4' },
                  { value: '5' },
                ]}
                isMissing={(!props.formItem.values.total_number_institutions_attended  || props.formItem.values.total_number_institutions_attended === '0') && props.check}
                disabled={props.disabled}
              />
            </Grid>
            
            <div className='bg-white p-3 rounded-3 w-100'>
            <Grid xs={12}>
              {(props.formItem.values.parent_graduation_college_array ?? []).map(
                (item: any, index: number) => (
                  <div key={index}>
                    <EducationConfig
                      check={props.check}
                      index={index}
                      formik={props.formItem}
                      item={item}
                      indexText={`${index + 1}/${props.formItem.values.parent_graduation_college_array.length
                        }`}
                      indexExpand={`${props.indexExpand}/${props.formItem.values.parent_graduation_college_array.length}`}
                      disabled={props.disabled}
                    />
                  </div>
                )
              )}
            </Grid>
            </div>
          </>
        )}
    </>
  );
};

export default Education;
